module.exports = __webpack_public_path__ + "img/reference40.49db3885.jpg";